// extracted by mini-css-extract-plugin
export default {"loginUser":"LoginUser_loginUser__+1HEq"};